import drive from './data-set/drive'
import exports from "@/store/app/office/recovery/team/exports";
import restores from "@/store/app/office/recovery/team/restores";
import backups from "@/store/app/office/recovery/team/backups";
import {createBackup, getTeamDetails, listSnapshots, listTeams} from "@/services/api/app/office/recovery/team/team";
import conversation from './data-set/conversation'
import mail from './data-set/mail'
import calendar from './data-set/calendar'
import metadata from './data-set/metadata'
import {defaultPagination} from "@/services/pagination";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";
import {exportSnapshot} from "@/services/api/app/office/recovery/one-drive/oneDrive";

const defaultState = () => ({
  teams: [],
  teamMap: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  listRegions: {},
  listRegionsGcp: {}
});

export default {
  namespaced: true,
  actions: {
    listTeams({commit, state},) {
      return listTeams({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result, pagination}) => {
          commit('setTeams', result)
          commit('setPagination', pagination)
        })
    },
    getTeamDetails({commit}, teamId) {
      return getTeamDetails(teamId)
        .then(team => {
          commit('setTeam', team);
          return team;
        })
    },
    createBackup({commit}, teamId) {
      return createBackup(teamId);
    },
    listSnapshots({commit}, {teamId, date, dateTo}) {
      return listSnapshots({teamId, date, dateTo})
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '3'
      });
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    }
  },

  mutations: {
    setTeams(state, teams) {
      state.teams = teams;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'name',
          sortDescending: false
        };
      }

    },
    setSearch(state, search) {
      state.search = search;
    },
    setTeam(state, team) {
      state.teamMap = {
        ...state.teamMap,
        [team.teamId]: team
      };
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getTeamById: (state) => (id) => {
      return state.teamMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState,

  modules: {
    drive,
    conversation,
    mail,
    calendar,
    metadata,
    
    exports,
    restores,
    backups,
  },

}
